import image from './melt.mp4';
import text from './text';

export const story = {
    slug: 'melt',
    title: 'Melt',
    interactive: 'melt',
    img: image,
    year: 'Like ice cream and chocolate',
    tags: ['horror'],
    md: text,
}